export const slugify = (str) =>
  str
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "")

export const slugifyCollection = (str) => encodeURIComponent(str.toLowerCase())
